import { Snowflake, TreePine } from "lucide-react";
import { PageShell } from "../components/PageShell";
import { PresentPanel } from "../components/home/PresentPanel";
import { PresentsSeoSection } from "../components/seo/PresentsSeoSection";
import { PRESENTS_SEO as S } from "../data/presentsSeo";
import { faqJsonLd, SITE_URL, useSeo } from "../lib/seo";
import { useSiteSettings } from "../lib/siteSettings";

const XMAS = {
  h1: "Christmas Gift Finder: What Present Should I Buy?",
  intro: "Stuck on Christmas presents? Tell DITHER who it's for, your budget and their vibe, and get five festive ideas in seconds — from stocking fillers to big under-the-tree surprises.",
};

function FestiveRibbon() {
  return (
    <div className="relative mb-2 flex items-center gap-2 overflow-hidden rounded-2xl border-[3px] border-[#0B3D2E] bg-[#1F8A4C] px-3 py-2 text-white shadow-[0_4px_0_#0B3D2E]" data-testid="presents-festive-ribbon">
      <TreePine className="h-6 w-6 shrink-0 text-[#FFE14D]" strokeWidth={2.5} />
      <p className="font-comic text-sm sm:text-base">Christmas picks first — Secret Santa, stocking fillers & big-day gifts sorted.</p>
      <Snowflake className="absolute -right-2 -top-2 h-12 w-12 text-white/20" />
      <Snowflake className="absolute bottom-0 right-14 h-6 w-6 text-white/20" />
    </div>
  );
}

export default function PresentFinder() {
  const festive = useSiteSettings()?.theme === "christmas";
  useSeo({
    title: S.title, description: S.description, ogTitle: S.ogTitle, ogDescription: S.ogDescription, path: "/presents",
    image: `${SITE_URL}/api/share/presents.png`,
    jsonLd: [{ "@context": "https://schema.org", "@type": "WebApplication", name: "DITHER Gift Finder", url: `${SITE_URL}/presents`, applicationCategory: "LifestyleApplication", operatingSystem: "Any", offers: { "@type": "Offer", price: "0", priceCurrency: "GBP" } }, faqJsonLd(S.faqs)],
  });
  return (
    <PageShell title={festive ? XMAS.h1 : S.h1} subtitle={festive ? XMAS.intro : S.intro} back="" testId="present-finder-page">
      {festive && <FestiveRibbon />}
      <PresentPanel big />
      <PresentsSeoSection />
    </PageShell>
  );
}
